/**
 * League System Terms & Conditions
 *
 * This file contains the legal terms that users must accept when creating
 * or joining a league. Keep all legal text centralized here for easy updates.
 */

export const LEAGUE_TERMS_VERSION = '1.0.0';
export const LEAGUE_TERMS_LAST_UPDATED = 'January 2025';

export const LEAGUE_TERMS_TITLE = 'League Terms of Use & Liability Waiver';

export const LEAGUE_TERMS_SUMMARY = `By creating or joining a league, you agree to our Terms of Use and acknowledge that UBSports provides software services only and assumes no liability for user content, communications, or events.`;

export const LEAGUE_TERMS_FULL = `
LEAGUE TERMS OF USE AND LIABILITY WAIVER

Last Updated: ${LEAGUE_TERMS_LAST_UPDATED}
Version: ${LEAGUE_TERMS_VERSION}

Please read these terms carefully before creating or joining a league.

1. SOFTWARE SERVICES ONLY

UBSports ("we," "us," or "our") provides league management software as a service. We are a technology platform that enables users to organize, coordinate, and manage recreational sports leagues and tournaments. We do not operate, supervise, or control any leagues, events, or activities organized by users of our platform.

2. USER RESPONSIBILITY

By creating or joining a league on our platform, you acknowledge and agree that:

a) You are solely responsible for all content you upload, post, or share, including but not limited to messages, photos, team information, and event details.

b) You are solely responsible for organizing, conducting, and participating in any events, games, or activities arranged through the platform.

c) You will comply with all applicable local, state, and federal laws when using the platform and participating in league activities.

d) You are at least 18 years of age, or have parental/guardian consent to use this platform.

3. NO MODERATION GUARANTEE

We do not actively monitor, moderate, or review user-generated content including:
- Messages sent between league members
- Photos uploaded to league galleries
- Team names, descriptions, or other user-provided information
- Event details or scheduling information

While we may remove content that violates our policies when reported, we make no guarantee of content moderation and are not responsible for any content posted by users.

4. ASSUMPTION OF RISK

Participation in sports and recreational activities involves inherent risks of injury. By using this platform to organize or participate in league activities, you:

a) Acknowledge that sports activities carry risk of physical injury, property damage, and other hazards.

b) Voluntarily assume all risks associated with participating in any events organized through the platform.

c) Agree that neither UBSports nor its affiliates, officers, employees, or agents shall be liable for any injuries, damages, or losses arising from your participation in league activities.

5. LIMITATION OF LIABILITY

TO THE MAXIMUM EXTENT PERMITTED BY LAW:

a) UBSports shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the platform or participation in any league activities.

b) UBSports shall not be liable for any disputes, conflicts, or issues arising between league members, teams, or organizers.

c) UBSports shall not be liable for any injuries, accidents, property damage, or other harm occurring during league events or activities.

d) Our total liability for any claims arising from your use of the platform shall not exceed the amount you paid to us in the twelve (12) months preceding the claim.

6. INDEMNIFICATION

You agree to indemnify, defend, and hold harmless UBSports, its affiliates, officers, directors, employees, agents, and licensors from any claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising from:

a) Your use of the platform
b) Your violation of these terms
c) Your violation of any rights of another party
d) Any content you upload or share through the platform
e) Any events or activities you organize or participate in through the platform

7. CONTENT GUIDELINES

While we do not actively moderate content, users agree not to upload or share content that:

a) Is illegal, harmful, threatening, abusive, harassing, defamatory, or invasive of privacy
b) Infringes on any intellectual property rights
c) Contains malware or harmful code
d) Promotes illegal activities
e) Is obscene or inappropriate for all ages

We reserve the right to remove any content and terminate accounts that violate these guidelines.

8. DISPUTE RESOLUTION

Any disputes arising from these terms or your use of the platform shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. You waive any right to participate in class action lawsuits against UBSports.

9. MODIFICATIONS

We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the modified terms.

10. GOVERNING LAW

These terms shall be governed by the laws of the State of Delaware, without regard to conflict of law principles.

11. SEVERABILITY

If any provision of these terms is found unenforceable, the remaining provisions shall continue in full force and effect.

12. ENTIRE AGREEMENT

These terms constitute the entire agreement between you and UBSports regarding the use of the league management platform.

BY CREATING OR JOINING A LEAGUE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS.
`.trim();

export const LEAGUE_TERMS_CHECKBOX_LABEL = `I have read and agree to the League Terms of Use & Liability Waiver`;

export const LEAGUE_TERMS_SHORT_NOTICE = `UBSports provides software services only. We are not responsible for user content, communications, or events organized through this platform.`;
